import { PAYMENT_CONFIG } from 'state/paymentConfig/type';

// Tab enum
export enum AdminConfigurationTab {
  MANAGE_PROCESSORS = 'MANAGE_PROCESSORS',
  FEATURE_FLAGS = 'FEATURE_FLAGS',
  OTHER_CONFIGS = 'OTHER_CONFIGS',
}

// Manage Processors types
export interface ProcessorTableData extends PAYMENT_CONFIG.IProcessors {
  _paymentMethod: string;
  _status: string;
  _enableDisable?: string;
  _actions?: string;
}

export interface ManageProcessorsProps {
  activeTab: AdminConfigurationTab;
  setActiveTab: (tab: AdminConfigurationTab) => void;
}

// Feature Flags types
export interface FeatureFlagsState {
  enableSystemConfiguration: boolean;
  enableAsyncMode: boolean;
}

export const FEATURE_FLAG_CONFIG_MAP = {
  enableAsyncMode: 'tfiAsyncMode',
  // Add more mappings here for future feature flags
  // enableSystemConfiguration: 'systemConfigCode',
} as const;

// Other Configs types
export interface ProcessorWebhookConfig {
  processorId: string;
  processorName: string;
  bypassEnabled: boolean;
  webhookStatus: string;
  statusOptions: Array<{ label: string; value: string }>;
}

export interface StatusMapper {
  defaultStatus: string;
  disabled: boolean;
  version: string;
  defaultField: string;
  mappings: StatusMapping[];
}

export interface StatusMapping {
  status: string;
  matches: string[];
}

export interface ProcessorStatusMappers {
  [processorId: string]: StatusMapper | null;
}

export interface ProcessorConfigurationData {
  id: string;
  version: number;
  configurations: unknown[];
  defaultConfigurations: unknown[];
  deviceConfigurationMode: string;
  defaultChannelConfig: unknown[];
  statusMapper?: StatusMapper | null;
}

export interface ProcessorConfigurationResponse {
  message: string;
  data: ProcessorConfigurationData;
  errorRaw: unknown;
}

export interface OtherConfigsProps {
  activeTab: AdminConfigurationTab;
  defaultProvider?: PAYMENT_CONFIG.IProcessors;
  setDefaultProvider: (provider?: PAYMENT_CONFIG.IProcessors) => void;
}
